import { render, staticRenderFns } from "./BigArrow.svg.vue?vue&type=template&id=9d61762e"
import script from "./BigArrow.svg.vue?vue&type=script&lang=ts"
export * from "./BigArrow.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d61762e')) {
      api.createRecord('9d61762e', component.options)
    } else {
      api.reload('9d61762e', component.options)
    }
    module.hot.accept("./BigArrow.svg.vue?vue&type=template&id=9d61762e", function () {
      api.rerender('9d61762e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/viewer/BigArrow.svg.vue"
export default component.exports